var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST, getBulkWeightDiscrepancyCountFailure, getBulkWeightDiscrepancyCountSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const getBulkWeightDiscrepancyCount = (action) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("getWeightDiscrepancy action", action.payload);
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const { tenantId } = action.payload;
        try {
            APIIN.get(`/report/admin/weight/dispute/batch/total/count?tenantId=${tenantId}`)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getBulkWeightDiscrepancyCountWorker(action) {
    try {
        const Count = yield call(getBulkWeightDiscrepancyCount, action);
        yield put(getBulkWeightDiscrepancyCountSuccess(Count));
    }
    catch (error) {
        yield put(getBulkWeightDiscrepancyCountFailure(error));
    }
}
export function* watchGetBulkWeightDiscrepancyCount() {
    yield takeLatest(GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST, getBulkWeightDiscrepancyCountWorker);
}
